import type {
  PenilikPegawaiProfile,
  PenilikPegawaiRoleType,
} from 'types/kinerja-penilik-pegawai'

/**
 * Checks if a user has a specific role.
 * @param data - The user's profile data.
 * @param role - The role to check.
 * @returns Returns true if the user has the specified role, otherwise false.
 */
export const isUserHasRole = (
  data: PenilikPegawaiProfile,
  role: PenilikPegawaiRoleType
) => {
  if (!data) return false

  return (
    data?.roles?.some((item: PenilikPegawaiRoleType) => {
      return item === role
    }) || false
  )
}

/**
 * Checks if the user has the PENILIK role.
 * @param data - The PenilikPegawaiProfile data.
 * @returns A boolean indicating whether the user has the PENILIK role.
 */
export const isUserPenilikPegawai = (data: PenilikPegawaiProfile) => {
  return isUserHasRole(data, 'PENILIK')
}
